import ScreenPromotedAdList from 'screens/PromotedAd/List';
import ScreenPromotedAdCreate from 'screens/PromotedAd/Create';
import ScreenPromotedAdUpdate from 'screens/PromotedAd/Update';
import ScreenPromotedAdDetails from 'screens/PromotedAd/Details';
import { PROMOTED_AD } from 'routes/paths';

const promotedAdsRoutes = [
  {
    path: PROMOTED_AD.LIST,
    name: 'PromotedAdList',
    component: ScreenPromotedAdList,
    loginRequired: true,
    allowPermissions: ['list_ownership_promotedad', 'list_promotedad'],
  },
  {
    path: PROMOTED_AD.CREATE,
    name: 'PromotedAdCreate',
    component: ScreenPromotedAdCreate,
    loginRequired: true,
    // allow view when user has permission to
    // add promoted ad or add ownership promoted ad
    // and has permission to list promoted ad packages
    allowPermissions: [
      ['add_promotedad', 'add_ownership_promotedad'],
      'list_promotedadpackage',
    ],
  },
  {
    path: PROMOTED_AD.UPDATE,
    name: 'PromotedAdUpdate',
    component: ScreenPromotedAdUpdate,
    loginRequired: true,
    // allow view when user has permission to
    // change promoted ad or change ownership promoted ad
    // and has permission to list promoted ad packages
    // and has permission to view promoted ad or view ownership promoted ad
    allowPermissions: [
      ['change_promotedad', 'change_ownership_promotedad'],
      'list_promotedadpackage',
      ['view_promotedad', 'view_ownership_promotedad'],
    ],
  },
  {
    path: PROMOTED_AD.DETAILS,
    name: 'PromotedAdDetails',
    component: ScreenPromotedAdDetails,
    allowPermissions: ['view_ownership_promotedad', 'view_promotedad'],
  },
];

export default promotedAdsRoutes;
